var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('UpdatePassword'),_vm._v(" "),_c('showProfile'),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('div',{attrs:{"id":"overlay"}},[_c('font-awesome-icon',{staticClass:"loading-icon",attrs:{"icon":"spinner","size":"2x","pulse":""}})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e77c7f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Default.vue
// module id = null
// module chunks = 